import ServicesList from './ServicesList';

export { type ServicesListProps } from './ServicesList';
export default ServicesList;
